import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import theme from '../../theme';

ChartJS.register(ArcElement, Tooltip, Legend);

interface WorkTypePieChartProps {
  underMaintenance: number;
  accidentRepair: number;
  alQouz: number;
  agency: number;
  others: number;
}

export const WorkTypePieChart: React.FC<WorkTypePieChartProps> = ({
  underMaintenance,
  accidentRepair,
  alQouz,
  agency,
  others,
}) => {
  const isWeb = Platform.OS === 'web';

  if (!isWeb) {
    return (
      <View style={styles.fallback}>
        <Text style={styles.fallbackText}>Chart available on web only</Text>
      </View>
    );
  }

  const data = {
    labels: ['Maintenance', 'Accident', 'Al Qouz', 'Agency', 'Others'],
    datasets: [
      {
        data: [underMaintenance, accidentRepair, alQouz, agency, others],
        backgroundColor: [
          '#3b82f6', // Blue
          '#ef4444', // Red
          '#10b981', // Green
          '#f59e0b', // Orange
          '#8b5cf6', // Purple
        ],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'right' as const,
        labels: {
          padding: 15,
          font: {
            size: 12,
          },
          generateLabels: (chart: any) => {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map((label: string, i: number) => {
                const value = data.datasets[0].data[i];
                const total = data.datasets[0].data.reduce((a: number, b: number) => a + b, 0);
                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                return {
                  text: `${label}: ${value} (${percentage}%)`,
                  fillStyle: data.datasets[0].backgroundColor[i],
                  hidden: false,
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
            return `${label}: ${value} vehicles (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <View style={styles.container}>
      <Pie data={data} options={options} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.surface,
    borderRadius: 12,
    padding: 20,
    height: 300,
  },
  fallback: {
    backgroundColor: theme.colors.surface,
    borderRadius: 12,
    padding: 40,
    alignItems: 'center',
    justifyContent: 'center',
    height: 300,
  },
  fallbackText: {
    fontSize: 14,
    color: theme.colors.textSecondary,
  },
});
